import type { CSSProperties } from "react";
import { GOOGLE_PLAY_URL, IOS_APP_URL } from "@/utils/appDownload";

const APP_BADGES = [
  {
    href: IOS_APP_URL,
    src: "/img/app-store/download-on-the-app-store.svg",
    alt: "Download on the App Store",
    label: "Download Roave on the App Store",
  },
  {
    href: GOOGLE_PLAY_URL,
    src: "/img/google-play/get-it-on-google-play.svg",
    alt: "Get it on Google Play",
    label: "Get Roave on Google Play",
  },
] as const;

type AppDownloadBadgesProps = {
  className?: string;
  style?: CSSProperties;
  badgeStyle?: CSSProperties;
};

export default function AppDownloadBadges({
  className,
  style,
  badgeStyle,
}: AppDownloadBadgesProps) {
  return (
    <div
      className={className}
      style={{
        display: "flex",
        gap: 10,
        flexWrap: "wrap",
        alignItems: "center",
        ...style,
      }}
    >
      {APP_BADGES.map((badge) => (
        <a
          key={badge.href}
          href={badge.href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={badge.label}
          style={{ display: "inline-flex", lineHeight: 0, textDecoration: "none" }}
        >
          <img
            src={badge.src}
            alt={badge.alt}
            width={135}
            height={40}
            style={{ display: "block", height: 40, width: 135, ...badgeStyle }}
          />
        </a>
      ))}
    </div>
  );
}
